import gql from 'graphql-tag';

import { useMetricQueries } from '../../lib/hooks';
import { createBatchedFetcher } from '../../lib/gqlFetcher_myf2b';

const fetcher = createBatchedFetcher(400, 1000, 200);

const QUERY = gql`
	query metrics_contentTreeProgress(
		$entityType: EntityType!,
		$entityId: ID!,
		$curriculumId: String!,
		$path: ContentTreePath!,
	) {
		metrics(entityId: $entityId, entityType: $entityType) {
			contentTreeProgress(curriculumId: $curriculumId, path: $path) {
				completed
				percent
				total
			}
		}
	}
`;

const useContentTreeProgresses = (entities) => useMetricQueries(
	entities.map(
		([entityType, entityId, curriculumId, path]) => ({
			document: QUERY,
			variables: { entityType, entityId, curriculumId, path },
			options: {
				queryKey: ['metrics_contentTreeProgress', entityType, entityId, curriculumId, path],
				transformer: (d) => ({
					entityType,
					entityId,
					curriculumId,
					path,
					progress: d.metrics.contentTreeProgress,
				}),
			},
		})
	),
	fetcher,
);
export default useContentTreeProgresses;
